import { establishPublishingConnectionSaga } from 'features/streaming/sagas/establishPublishingConnectionSaga';
import { UserId } from 'features/users/types';
import { call, put, select } from 'redux-saga/effects';
import { selectLocalUserId } from 'features/users/usersSlice';
import { PublishingFeedStatus, RTCClient } from 'utils/webrtc';
import { eventBus } from 'utils/eventBus';
import { selectLocalFeedStatus } from 'features/streaming/streamingSlice';
import { broadcastSetupStarted, selectIsBroadcastSetupActive } from 'features/room/roomSlice';
import { updateOrderSaga } from 'features/layout/sagas/updateOrderSaga';
import { broadcastPermissionGranted } from 'features/permissions/actions';
import { muteVideoSaga } from 'features/streaming/sagas/muteVideoSaga';
import { muteAudioSaga } from 'features/streaming/sagas/muteAudioSaga';

export function* onBroadcastPermissionGrantedSaga({
  payload,
}: ReturnType<typeof broadcastPermissionGranted>) {
  const { id } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);

  if (localUserId !== id) {
    yield call(updateOrderSaga, id);
    return;
  }

  const publishingFeedStatus: PublishingFeedStatus = yield select(selectLocalFeedStatus);
  // establish a publishing connection and initiate broadcast setup
  // if no active connection exists
  if (publishingFeedStatus === PublishingFeedStatus.idle) {
    RTCClient.publishingFeed.broadcastIntended = true;
    yield call(establishPublishingConnectionSaga, true);
  } else {
    // mute existing broadcast for privacy reasons,
    // the user will reconfigure his devices in a moment
    if (payload.video) {
      yield call(muteVideoSaga);
    }
    yield call(muteAudioSaga);
  }

  const isBroadcastSetupActive: boolean = yield select(selectIsBroadcastSetupActive);
  if (!isBroadcastSetupActive) {
    yield put(broadcastSetupStarted({ reason: 'promotion' }));
  }

  yield call(
    eventBus.sendMessage,
    'permissionsChanged',
    {},
    {
      broadcast: true, // For backward compatibility
      broadcastAudio: payload.audio,
      broadcastVideo: payload.video,
    }
  );
}
